module.exports = __webpack_public_path__ + "static/media/icon-lightbulb.b5d7a5ca.svg";